import { useRouter } from 'next/router'
import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { NavigationEvents, ProductLine } from '@mc/track-event'
import { trackBrowseSkillsCatalogCTAClick } from './utils'

interface BrowseSkillsLibraryCtaProps {
  textCTAKey: string
  className?: string
}

export const BrowseSkillsLibraryCta = ({
  textCTAKey,
  className = '',
}: BrowseSkillsLibraryCtaProps) => {
  const { t } = useTranslation('@mc/next')
  const { pathname, query } = useRouter()

  return (
    <Button
      render={<a href={paths.enterpriseSkillsLibrary} />}
      kind='link'
      className={`mc-text--bold ${className}`}
      symmetrical
      onClick={trackBrowseSkillsCatalogCTAClick({
        action: t(textCTAKey),
        level: NavigationEvents.LEVELS.PRIMARY,
        pathname,
        query,
        product: ProductLine.AT_WORK,
      })}
    >
      {t(textCTAKey)}
    </Button>
  )
}
